import { useQuery } from '@tanstack/react-query'
import getProgramConfig from '@/services/ruutsApi/getProgramConfig'
import { queryKeys } from './queryKeys'

export const useProgramConfig = (farmId: string | undefined) =>
  useQuery({
    queryKey: queryKeys.programConfig(farmId),
    queryFn: ({ signal }) => getProgramConfig({ farmId: farmId as string, signal }),
    enabled: !!farmId,
  })
